export type NoteDuration = 1 | 2 | 4 | 8 | 16 | number;

export enum NoteDurations {
    Whole = 1,
    Half = 2,
    Quarter = 4,
    Eight = 8,
    Sixteenth = 16
}